import { render, staticRenderFns } from "./myNews.vue?vue&type=template&id=3c552fa8&scoped=true"
import script from "./myNews.vue?vue&type=script&lang=js"
export * from "./myNews.vue?vue&type=script&lang=js"
import style0 from "./myNews.vue?vue&type=style&index=0&id=3c552fa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c552fa8",
  null
  
)

export default component.exports